import { _keys, EmptyObject, exists, reduceToMap } from '@nu-art/ts-common';
import { openContent } from '../component-modules/mouse-interactivity/index.js';
export const convertToHTMLDataAttributes = (attributes, prefix) => {
    if (!attributes)
        return EmptyObject;
    const finalImpl = prefix ? `${prefix}-` : '';
    return reduceToMap(_keys(attributes), key => `data-${finalImpl}${key}`, key => attributes[key]);
};
export const getErrorTooltip = (errors, shouldReturn = false) => {
    if (!exists(errors) || !shouldReturn)
        return {};
    return openContent.tooltip.top('input-error-tooltip', () => errors.message, { offset: 6 });
};
export const resolveEditableError = (errorHandler) => {
    if (errorHandler.ignoreError)
        return;
    if (errorHandler.error)
        return errorHandler.error;
    const errorMessage = errorHandler.editable.hasError(errorHandler.prop);
    if (!errorHandler.error && errorMessage)
        return { level: 'error', message: String(errorMessage) };
};
//# sourceMappingURL=types.js.map